export default "__VITE_ASSET__BhcHpt4r__"